export default "__VITE_ASSET__BKaMca55__"